export * from './IconCamera';
